import { useEffect, useRef, useState } from "react";
import { Outlet, useParams } from "react-router-dom";
import { useSample } from "../../utils/useSample";
import useAnalysis from "../../utils/useAnalysis";
import {
  useDosimetros,
  useEquipment,
  useEquipmentMide,
  useIsotopos,
  useIsotoposInstalacion,
  useLaboratory,
  useProcessingCategory,
  useReagents,
  useReceiver,
  useSamplingPoints,
  useSamplingProcedMuestreo,
  useSamplingProcedure,
  useSamplingReason,
  useTypesAccumulation,
  useTypeSample,
  useTypesUnits,
  useUser,
} from "@services/servicesGenericsTables";
import { Loading } from "@app/components";
import { useDetector } from "@services/servicesGenericsTables/useDetector";
import { useBackground } from "@app/pages/background/utils/useBackground";
import { useBackgroundCodes } from "@services/servicesGenericsTables/useBackgroundCodes";

export default function ConditioningLayout() {
  const fetched = useRef(false);
  const { idMuestra } = useParams();
  const [loading, setLoading] = useState(true);
  const { fetchAll } = useSamplingPoints();
  const { fetchAll: fetchAllSamplingReason } = useSamplingReason();
  const { fetchAll: fetchAllAccumulation } = useTypesAccumulation();
  const { fetchAll: fetchAllTypeSample } = useTypeSample();
  const { fetchAll: fetchAlluser } = useUser();
  const { fetchAll: fetchAllSamplingProcedure } = useSamplingProcedMuestreo();
  const { fetchAll: fetchAllTypesUnits } = useTypesUnits();
  const { fetchAll: fetchAllEquipment } = useEquipment();
  const { fetchAll: fetchAllReagents } = useReagents();
  const { fetchAll: fetchAllProcessingCategory } = useProcessingCategory();
  const { fetchAll: fetchAllProcedure } = useSamplingProcedure();
  const { fetchAll: fetchAllLaboratory } = useLaboratory();
  const { fetchAll: fetchAllReceiver } = useReceiver();
  const { fetchAll: fetchAllEquipmentMide } = useEquipmentMide();
  const { fetchAll: fetchAllDetectores } = useDetector();
  const { fetchAll: fetchAllBackground } = useBackground();
  const { fetchAll: fetchAllDosimetros } = useDosimetros();
  const { fetchAll: fetchAllIsotopos } = useIsotopos();
  const { fetchAll: fetchAllIsotoposIntalation } = useIsotoposInstalacion();
  const { fetchAll: fetchAllBackgroundCodes } = useBackgroundCodes();

  const { getAndSet } = useSample();
  const { resetState } = useAnalysis();

  useEffect(() => {
    if (!fetched.current) {
      fetched.current = true;

      const fetchData = async () => {
        resetState();
        await Promise.all([
          getAndSet(Number(idMuestra)),
          fetchAll(),
          fetchAllSamplingReason(),
          fetchAllAccumulation(),
          fetchAllTypeSample(),
          fetchAlluser(),
          fetchAllSamplingProcedure(),
          fetchAllTypesUnits(),
          fetchAllEquipment(),
          fetchAllReagents(),
          fetchAllProcessingCategory(),
          fetchAllProcedure(),
          fetchAllLaboratory(),
          fetchAllReceiver(),
          fetchAllEquipmentMide(),
          fetchAllDetectores(),
          fetchAllBackground(),
          fetchAllDosimetros(),
          fetchAllIsotopos(),
          fetchAllIsotoposIntalation(),
          fetchAllBackgroundCodes(),
        ]);
        setLoading(false);
      };
      fetchData();
    }
  }, [idMuestra]);

  return loading ? <Loading /> : <Outlet />;
}
